import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { MuiRemixLink } from './links';

export type BreadcrumbEntry = { name: string; href?: string };

export default function Breadcrumb({ entries }: { entries: BreadcrumbEntry[] }) {
  return (
    <div role="presentation">
      <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
        {entries.map((entry, index) =>
          index === entries.length - 1 || !entry.href ? (
            <Typography key={`${entry.name}-${entry.href}`} color="text.primary" aria-current="page">
              {entry.name}
            </Typography>
          ) : (
            <MuiRemixLink key={`${entry.name}-${entry.href}`} href={entry.href} underline="hover" color="inherit">
              {entry.name}
            </MuiRemixLink>
          )
        )}
      </Breadcrumbs>
    </div>
  );
}
